import React from 'react';
import PropTypes from 'prop-types';
import { Card } from '../../../Card/Card';
import { FULL_TABLE_CATEGORIES } from '../../../../settings/full-table';
import { STATS } from '../../../StatsLeaders/config/stats';
import { getTranslation } from '../../../../../../../../common/react/utils/translations';
import SwiperCore, { EffectCoverflow } from 'swiper';
import { TeamWatermarkBackground } from '../../../TeamWatermarkBackground';

SwiperCore.use( [ EffectCoverflow ] );

/**
 * @param {object} props - Props.
 * @param {object} props.player - Player details.
 * @param {string} props.type - Category of slider.
 * @returns {JSX.Element} Component.
 */
// @ts-ignore
export const LastRoundHighsCard = ( { player, type } ) => {
    const fullTableInfo = FULL_TABLE_CATEGORIES[ player.category ];
    const translations = {
        category: STATS[ fullTableInfo.column ].name,
        averageAbbr: getTranslation( 'label.statspro.averageAbbr' ),
        roundAbbr: getTranslation( 'label.statspro.roundAbbr' )
    };
    
    return (
        <Card>
            <div className="statspro-card-featured-player">
                <div className="statspro-card-featured-player__inner-container">
                    <TeamWatermarkBackground
                        teamAbbreviation={ player.team.teamAbbr }
                        className="statspro-card-featured-player__bg"
                    />
                    <div className="statspro-card-featured-player__category-container">
                        <p className="statspro-card-featured-player__category">{ translations.category }</p>
                    </div>
                    <div className="statspro-card-featured-player__details">
                        <p className="statspro-card-featured-player__value">
                            { player.value }
                        </p>
                        { type === 'season' && !!player.seasonAverage &&
                            <span className="statspro-card-featured-player__average-value">
                                <span className="statspro-card-featured-player__average-value-text">{ translations.averageAbbr }. </span>
                                { player.seasonAverage }
                            </span>
                        }
                        <div className="statspro-card-featured-player__details-bottom">
                            <p className="statspro-card-featured-player__name">
                                { player.player.givenName } <span>{ player.player.surname }</span>
                            </p>
                            <p className="statspro-card-featured-player__match-label">
                                { player.matchLabel.split( ' ' ).map( x => { return x === 'v' ? x : x.toUpperCase(); } ).join( ' ' ) }
                            </p>
                        </div>
                    </div>
                    <div className="statspro-card-featured-player__photo-container">
                        <img className="statspro-card-featured-player__image" src={ player.player.photoURL.split( '?' )[ 0 ] } />
                    </div>
                </div>
            </div>
        </Card>
    );
};

LastRoundHighsCard.propTypes = {
    player: PropTypes.object.isRequired,
    type: PropTypes.string.isRequired
};